import React, { useMemo } from 'react';
import { Button, Skeleton, Space } from 'antd';
import { useIntl } from 'react-intl';

import { ActionButtons, Body, Container, Description, Header, LeftHeader, SubTitle, Title } from './styles';

export interface ViewPanelProps {
  title?: string | React.ReactNode;
  subtitle?: string;
  theme?: string;
  // eslint-disable-next-line no-unused-vars
  onClick?: (id: string) => void;
  spaceOptions?: object;
  desc?: string;
  children: React.ReactNode;
  content?: [];
  actions?: [];
  buttons?: any[];
  leftButtons?: any[];
  controls?: any[];
  flat?: boolean;
  queryId?: string;
  style?: object;
  loading?: boolean;
  layout?: 'vertical' | 'horizontal';
}

const ViewPanel = ({
  title = '제목',
  buttons,
  leftButtons,
  spaceOptions = { size: 16 },
  theme = 'default',
  subtitle,
  desc,
  children,
  controls,
  style,
  loading = false,
  onClick = () => {},
  layout = 'vertical'
}: ViewPanelProps) => {
  const intl = useIntl();
  const _title = useMemo(() => {
    if (typeof title === 'string') {
      try {
        return intl.formatMessage({ id: title });
      } catch (e) {
        return title;
      }
    } else {
      return title;
    }
  }, [title]);

  const _subtitle = useMemo(() => {
    try {
      return intl.formatMessage({ id: subtitle });
    } catch (e) {
      return subtitle;
    }
  }, [subtitle]);

  const _desc = useMemo(() => {
    if (!desc) return null;
    return intl.formatMessage({ id: desc });
  }, [desc]);

  return (
    <Container style={{ ...style }} className={theme}>
      <Header>
        {leftButtons && <ActionButtons>{leftButtons}</ActionButtons>}
        <LeftHeader>
          <div className="mainTitle">
            <Title>{_title || title}</Title>
          </div>
          {subtitle && <SubTitle>{_subtitle || title}</SubTitle>}
        </LeftHeader>
        <Space>
          {controls &&
            controls.map((control) => {
              const { id, icon, component, title: controlTitle, _onClick } = control;
              if (icon) {
                return (
                  <Button
                    size="small"
                    icon={icon}
                    onClick={() => {
                      if (_onClick) _onClick();
                      onClick(id);
                    }}
                  >
                    {controlTitle}
                  </Button>
                );
              }
              if (component) {
                return component;
              }
              return null;
            })}
          {buttons && <ActionButtons>{buttons}</ActionButtons>}
        </Space>
      </Header>
      {desc ? (
        <Description>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: _desc }} />
        </Description>
      ) : null}
      <Body layout={layout}>
        <Skeleton loading={loading} active avatar>
          <Space direction="vertical" {...spaceOptions}>
            {children}
          </Space>
        </Skeleton>
      </Body>
    </Container>
  );
};

export default ViewPanel;
